'use strict';

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';
import Footer from './Footer.jsx';
import RadioButton from './RadioButton.jsx';
import { GenericErrorScreen, GenericSimpleButton, GenericAlert} from 'com-gyf-webcore-userinterfacecomponents';
import Breadcrumb from '../../NuevaSolicitudAdministradora/components/MarcaBreadcrumb.jsx';
import ClienteTitle from '../../NuevaSolicitudAdministradora/components/ClienteTitle.jsx';


class NuevaSolicitudTipoEmpresa extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumb: [],
            letraFiltro: "I",
            empresasFiltradas: [],
        }
        this.breadcrumbGenerator = this.breadcrumbGenerator.bind(this)
        this.cambiarFiltroIndividuo = this.cambiarFiltroIndividuo.bind(this)
    }

    componentDidMount() {
        let clienteTipo = this.props.tarjetas.clienteResultadoBusqueda.esPersonaFisica ? "I" : "E";
        this.props.getScreenData(this.props.currentScope);
        this.breadcrumbGenerator(this.props.tarjetas.administradora.Id, clienteTipo);
    }
    
    componentWillUnmount() {
        this.props.resetStateSolicitudTipoEmpresa();
    }
    
    cambiarFiltroIndividuo() {
        
        if (this.state.letraFiltro == "I") {
            this.setState({ letraFiltro: "E" })
            this.setState({ empresasFiltradas: this.props.data.tipoEmpresa.filter((emp) => emp.EmpresaIndividuos == "E") })
            this.breadcrumbGenerator(this.props.tarjetas.administradora.Id, "E");
        } else {
            this.setState({ letraFiltro: "I" })
            this.setState({ empresasFiltradas: this.props.data.tipoEmpresa.filter((emp) => emp.EmpresaIndividuos == "I") })
            this.breadcrumbGenerator(this.props.tarjetas.administradora.Id, "I");
        }
        
        this.props.deselectTipoEmpresa();
    }
    componentWillReceiveProps(nextProps) {
        
        //FILTRO AUTOMÁTICO DE TIPOS DE CUENTA SEGÚN HAYA O NO SELECCIONADO ALGUNO (POR SI SE ESTÁ VOLVIENDO DE UNA PANTALLA POSTERIOR)
        if (!nextProps.tarjetas.tipoEmpresaId && this.state.empresasFiltradas.length < 1 && nextProps.data.tipoEmpresa && this.props.tarjetas.clienteResultadoBusqueda.tipoCliente == "Persona Física") {
            this.setState({ empresasFiltradas: nextProps.data.tipoEmpresa.filter((emp) => emp.EmpresaIndividuos == (this.props.tarjetas.tipoEmpresa.EmpresaIndividuos ? this.props.tarjetas.tipoEmpresa.EmpresaIndividuos : "I") ) })
            this.setState({letraFiltro: this.props.tarjetas.tipoEmpresa.EmpresaIndividuos ? this.props.tarjetas.tipoEmpresa.EmpresaIndividuos : "I" })
            this.breadcrumbGenerator(this.props.tarjetas.administradora.Id, this.props.tarjetas.tipoEmpresa.EmpresaIndividuos ? this.props.tarjetas.tipoEmpresa.EmpresaIndividuos : "I");
        }  
    }

    componentDidUpdate(){
        if(!this.props.tarjetas.tipoEmpresa.Id && this.props.data.tipoEmpresa && this.props.data.tipoEmpresa.length == 1 ){
            this.props.selectRadioButton(this.props.data.tipoEmpresa[0]);
        }
    }

    render() {

        if (this.props.data.redirectToAdministradora == true)
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudTipoEmpresa", "ROUTE_TO_ADMINISTRADORA")} push />

        if (this.props.data.redirectToVistaCliente == true)
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudTipoEmpresa", "ROUTE_TO_VISTA_CLIENTE")} push />

        if (this.props.data.redirectToCuenta == true)
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudEmpresa", "ROUTE_TO_CUENTA")} push />
        
            if (this.props.data.redirectToEmpresa == true)
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudTipoEmpresa", "ROUTE_TO_EMPRESA")} push />

        let permisos = this.props.data.permisos;

        if (permisos) {
            if (permisos.components.Pantalla.Active == true) {

                let genericAlert = this.props.data.showError ? <GenericAlert message={this.state.letraFiltro == "E" ? "Por favor, recuerde que debe seleccionar un Tipo de Empresa, ya que es parte de la solicitud.":"Por favor, recuerde que debe seleccionar un Tipo de Cuenta, ya que es parte de la solicitud."} type="danger" /> : null;

                return (
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <ClienteTitle
                                    cliente={this.props.tarjetas.clienteResultadoBusqueda}
                                    empresas={null}
                                    novedadesEmpresas={null}
                                    esModificacion={false}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-9">
                                <Breadcrumb className="breadcrumb"
                                    currentScreen={null}
                                    menu={this.state.breadcrumb}
                                    product={null}
                                    module={null} />
                            </div>
                            <div className="col-md-3">
                                {(this.props.tarjetas.clienteResultadoBusqueda.esPersonaFisica && this.props.tarjetas.administradora.Id == 1) && <div style={{ marginLeft: "65px" }}>
                                    <GenericSimpleButton buttonType="button" text={this.state.letraFiltro == "I" ? "Commercial Cards" : "Individuos"} buttonClass="btn btn-secondary" onClick={() => this.cambiarFiltroIndividuo()} />
                                </div>}
                            </div>
                        </div>

                        {genericAlert}

                        <div className="row">
                            <div className="col-md-12">
                                {<RadioButton
                                    empresaSeleccionada={this.props.data.tipoEmpresaSeleccionada}
                                    empresas={this.props.tarjetas.clienteResultadoBusqueda.esPersonaFisica ? this.state.empresasFiltradas : this.props.data.tipoEmpresa}
                                    data={this.props}
                                    selectRadioButton={this.props.selectRadioButton}
                                    tarjetas={this.props.tarjetas} />}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <Footer
                                    empresaSeleccionada={this.props.tarjetas.tipoEmpresa}
                                    permisos={permisos}
                                    routeToPrevious={this.props.routeToPrevious}
                                    showError={this.props.showError}
                                    routeToCuenta={this.props.routeToNuevaSolicitudCuenta}
                                    routeToVistaCliente={this.props.routeToVistaCliente}
                                    routeToAdministradora={this.props.routeToAdministradora}
                                    routeToEmpresa={this.props.routeToEmpresa}
                                    tarjetas={this.props.tarjetas}/>
                            </div>
                        </div>
                    </div>
                );
            } else {
                if (permisos.components.Pantalla.Active == false) {
                    let values = {
                        message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                        linkMessage: "Volver a mi pagina de inicio"
                    };
                    return <GenericErrorScreen data={values} />;
                }
            }
        } else {
            return null;
        }
    }

    breadcrumbGenerator(idAdm, letraFiltro) {
        let nuevaSolicitudMap = [];
        if (letraFiltro == "I") {
            nuevaSolicitudMap.push({ descripcion: this.props.tarjetas.administradora.Descripcion, ruta: "", activo: false, normal: true, anterior: true });
            nuevaSolicitudMap.push({ descripcion: "Tipo de Cuenta", ruta: "", activo: true, normal: false, anterior: false });
            nuevaSolicitudMap.push({ descripcion: "Datos de la Cuenta", ruta: "", activo: false, normal: true, anterior: false });
            nuevaSolicitudMap.push({ descripcion: "Adicionales", ruta: "", activo: false, normal: true, anterior: false });
        } else if (letraFiltro == "E") {
            if (idAdm == 1) {
                nuevaSolicitudMap.push({ descripcion: this.props.tarjetas.administradora.Descripcion, ruta: "", activo: false, normal: true, anterior: true });
                nuevaSolicitudMap.push({ descripcion: "Tipo de Empresa", ruta: "", activo: true, normal: false, anterior: false });
                nuevaSolicitudMap.push({ descripcion: "Empresa", ruta: "", activo: false, normal: true, anterior: false });
                nuevaSolicitudMap.push({ descripcion: "Datos de la Cuenta", ruta: "", activo: false, normal: true, anterior: false });
                nuevaSolicitudMap.push({ descripcion: "Extensiones", ruta: "", activo: false, normal: true, anterior: false });
            } else if (idAdm == 2) {
                nuevaSolicitudMap.push({ descripcion: this.props.tarjetas.administradora.Descripcion, ruta: "", activo: false, normal: true, anterior: false, anterior: true });
                nuevaSolicitudMap.push({ descripcion: "Tipo de Cuenta", ruta: "", activo: true, normal: false, anterior: false });
                nuevaSolicitudMap.push({ descripcion: "Datos de la Cuenta", ruta: "", activo: false, normal: true, anterior: false });
                nuevaSolicitudMap.push({ descripcion: "Extensiones", ruta: "", activo: false, normal: true, anterior: false });
            }
        }
        this.setState({ breadcrumb: nuevaSolicitudMap })
    }

}



export default NuevaSolicitudTipoEmpresa;
